import * as React from 'react';
import { AccordionItemContext, } from '../accordion-item/accordion-item-context';
export default class AccordionTitleCore extends React.Component {
    getIcon() {
        const { Icon, Image } = this.props.components;
        if (!this.context.icon) {
            return null;
        }
        if (typeof this.context.icon === 'string') {
            return (React.createElement("div", { className: "accordion__icon-wrapper" },
                React.createElement(Icon, { className: "accordion__icon", modifiers: this.context.icon })));
        }
        else {
            return (React.createElement("div", { className: "accordion__image-wrapper" },
                React.createElement(Image, Object.assign({}, this.context.icon, { className: "accordion__image" }))));
        }
    }
    getContent() {
        return (React.createElement(React.Fragment, null,
            this.getIcon(),
            React.createElement("div", { className: "accordion__label" }, this.props.children)));
    }
    render() {
        if (this.context.noContent) {
            return (React.createElement("div", { className: "accordion__title" }, this.getContent()));
        }
        return (React.createElement("a", { className: "accordion__title", href: '#' + this.context.id, onClick: this.context.onClick, onMouseEnter: this.context.onMouseEnter, onMouseLeave: this.context.onMouseLeave }, this.getContent()));
    }
}
AccordionTitleCore.contextType = AccordionItemContext;
